const displayShippingForm = (state = {}, action) => {
  switch (action.type) {
    case "OPENSF":
      return {
        ...state,
        display: "inline",
      };
    case "CLOSESF":
      return {
        ...state,
        display: "none",
      };
    default:
      return state;
  }
};

export default displayShippingForm;
